export const GET_USER_LIST_REQUEST = 'GET_USER_LIST_REQUEST'
export const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS'
export const GET_USER_LIST_FAILURE = 'GET_USER_LIST_FAILURE'

export const GET_SEARCHED_USERS_REQUEST = 'GET_SEARCHED_USERS_REQUEST'
export const GET_SEARCHED_USERS_SUCCESS = 'GET_SEARCHED_USERS_SUCCESS'
export const GET_SEARCHED_USERS_FAILURE = 'GET_SEARCHED_USERS_FAILURE'
